import VueI18n from "vue-i18n";
import { ApiClient } from "./client"

export class TranslationsProvider {
    private static _apiClient = new ApiClient();

    static async init(i18n: VueI18n) {
        const terms = await this.getTerminology(i18n.locale);
        const messages = Object.fromEntries(Object.entries(terms).map(([term, text]) => [`terms.${term.toLowerCase()}`, text]));
        i18n.mergeLocaleMessage(i18n.locale, messages);
    }

    static async getTranslations(lang: string) {
        return await this._apiClient.get(`/translations/${lang}`, true) as { [key: string]: string };
    }

    static async getTerminology(lang: string) {
        return await this._apiClient.get(`/translations/${lang}/terms`) as { [key: string]: string };
    }

}